import React, { useEffect, useState } from "react";
import "../PasswordConfirmation/PasswordConfirmation.css";
import { toast } from "react-toastify";
import { NavLink, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { useNotification } from "../../Context/NotificationContext";

const config = require("../../Helpers/config.json");
function PasswordConfirmation({ showModal, setShowModal, route }) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isForget, setisForget] = useState(false);
  const [newPassword, setNewPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [emailOTP, setEmailOTP] = useState(null);
  const [openModalForRePassword, setOpenModalForRePassword] = useState(false);
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const email = localStorage.getItem("email");
  function handleSubmit() {
    fetch(`${config["baseUrl2"]}auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          navigate(route);
        } else {
          setLoading(false);
          showNotification({
            title: 'Authentication Failed',
            message: data.error?.message || "Authentication failed",
            type: 'error'
          });
        }
      })
      .catch(() => {
        setLoading(false);
        showNotification({
          title: 'Error',
          message: "An error occurred during authentication",
          type: 'error'
        });
      });
  }
  const usercode = localStorage.getItem("userCode");

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      // Call your function here
      authentication();
    }
  };

  const authentication = () => {
    if (!password) {
      showNotification({
        title: 'Validation Error',
        message: "Please enter Master Key!",
        type: 'error'
      });
      return;
    }
    console.log('user code ===> ', usercode)
    if (usercode === password) {
      // navigate(route);
      if (route === '/account') {
        navigate(route, { state: { fromLink: true } });
      } else {
        navigate(route); // Navigate normally for other routes
      }
    } else {
      showNotification({
        title: 'Incorrect Master Key',
        message: "Incorrect Master Key!",
        type: 'error'
      });
    }
  };

  const hitEmailForForget = () => {
    setLoading(true);
    fetch(`${config["baseUrl2"]}v1/account-pin-reset-requests`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        email,
      }),
    })
      .then((res) => {
        setLoading(false);
        return res.json();
      })
      .then((res) => {
        if (res.message === 'Request accepted') {
          toast.success("Check your email for the reset code");
          setisForget(true);
        } else {
          showNotification({
            title: 'Request Failed',
            message: "Failed to request Master Key reset",
            type: 'error'
          });
        }
      })
      .catch(() => {
        setLoading(false);
        showNotification({
          title: 'Error',
          message: "An error occurred while requesting reset",
          type: 'error'
        });
      });
  };

  const reset = () => {
    setLoading(true);
    if (!newPassword || !confirmPassword) {
      setLoading(false);
      showNotification({
        title: 'Validation Error',
        message: 'Master Key field is empty!',
        type: 'warning'
      });
    } else if (newPassword !== confirmPassword) {
      setLoading(false);
      showNotification({
        title: 'Validation Error',
        message: "Master Key doesn't match!",
        type: 'warning'
      });
    } else if (newPassword === confirmPassword) {
      fetch(`${config['baseUrl2']}v1/account-pin-resets`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          token: emailOTP,
          newPin: newPassword,
        }),
      })
        .then((res) => {
          setLoading(false);
          if (res.ok || res.status === 204) {
            toast.success("Master Key reset successfully");
            localStorage.setItem("userCode", newPassword)
            navigate(route);
          } else {
            showNotification({
              title: 'Reset Failed',
              message: "Failed to reset Master Key",
              type: 'error'
            });
          }
        })
        .catch(() => {
          setLoading(false);
          showNotification({
            title: 'Error',
            message: "An error occurred during Master Key reset",
            type: 'error'
          });
        });
    }
  };

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        animation={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          {!isForget ? (
            <Modal.Title>Enter Master Key!</Modal.Title>
          ) : (
            <>
              <Modal.Title>Reset Master Key</Modal.Title>
            </>
          )}
        </Modal.Header>
        <Modal.Body className="Modal">
          {!isForget ? (
            <div className="main-div">
              <h6 className="headings">
                Looks like you've set up a Master Key for your Account page!{" "}
              </h6>
              <div className="password-container">
                {/* <h6 className='headings'>Email</h6>
                                <p className='email-sugest'>{email?.substring(0, 3)}***@gmail.com</p> */}
                <h6 className="headings">Please enter Master Key. 🗝️ </h6>
                <input
                  className="password-field"
                  type="password"
                  value={password}
                  placeholder="Master Key"
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  onKeyDown={(event) => handleKeyPress(event)}
                />
              </div>
              <div className="forgot-link-wrap">
                <NavLink
                  className="forgot-link"
                  onClick={() => {
                    hitEmailForForget();
                  }}
                >
                  Forgot Master Key ? Reset Here
                </NavLink>
              </div>
            </div>
          ) : (
            <>
              <div className="reset-password-wrap">
                <div className="reset-input-wrap">
                  <p className="input-names">OTP</p>
                  <input
                    className="reset-password-input"
                    type="password"
                    value={emailOTP}
                    placeholder="Enter your Otp Code"
                    onChange={(e) => {
                      setEmailOTP(e.target.value);
                    }}
                  />
                </div>
                <div className="reset-input-wrap">
                  <p className="input-names">Enter New Master Key 🗝️</p>
                  <input
                    className="reset-password-input"
                    type="password"
                    value={newPassword}
                    placeholder="New Master Key"
                    onChange={(e) => {
                      setNewPassword(e.target.value);
                    }}
                  />
                </div>
                <div className="reset-input-wrap">
                  <p className="input-names">Confirm Master Key 🗝️</p>
                  <input
                    className="reset-password-input"
                    type="password"
                    value={confirmPassword}
                    placeholder="Confirm Master Key"
                    onChange={(e) => {
                      setConfirmPassword(e.target.value);
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {!isForget ? (
            <div className="button-wrap">
              <button
                className="btn btn-cancel me-2 mt-0"
                onClick={() => {
                  setShowModal(false);
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-continue mt-0"
                onClick={() => {
                  authentication();
                }}
                disabled={!password}
              >
                Continue
              </button>
            </div>
          ) : (
            <>
              <div className="button-wrap">
                <button
                  className={`btn btn-cancel me-2 mt-0`}
                  onClick={() => {
                    setisForget(false);
                  }}
                >
                  Back
                </button>
                <button
                  className={`btn btn-continue mt-0 ${!emailOTP || !newPassword || !confirmPassword
                    ? "disabled"
                    : ""
                    }`}
                  onClick={reset}
                >
                  Continue
                </button>
              </div>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default PasswordConfirmation;
